import { View, Text } from "@lightningtv/solid";
import { For, Show } from "solid-js";
import theme from "theme";

const blockWidth = 1100;

const HeadlineStyles = {
  ...theme.typography.display2,
  fontFamily: "Roboto",
  fontWeight: 700,
  maxLines: 1,
  width: blockWidth * 1.5,
  contain: "width",
};
const Headline = (props) => <Text {...props} style={HeadlineStyles}></Text>;

const DescriptionStyles = {
  ...theme.typography.body1,
  fontFamily: "Roboto",
  fontWeight: 400,
  lineHeight: 32,
  width: blockWidth,
  maxLines: 2,
  contain: "width",
};

const DescriptionStylesSecond = {
  ...theme.typography.body1,
  fontFamily: "Roboto",
  fontWeight: 400,
  lineHeight: 32,
  width: blockWidth,
  maxLines: 2,
  contain: "width",
  fontSize: 22,
  color: '#ffffff'
};

const BadgeStyle = {
  fontSize: 16,
  lineHeight: 20,
  marginLeft: 13,
  marginRight: 13,
};

const Description = (props) => (
  <Text {...props} style={DescriptionStyles}>
    {props.children}
  </Text>
);

const DescriptionSecond = (props) => (
  <Text {...props} style={DescriptionStylesSecond}>
    {props.children}
  </Text>
);

export const Badge = (props) => {
  return (
    <View
      {...props}
      style={{
        color: "0x00000099",
        borderRadius: 8,
        border: { width: 2, color: "0xffffffff" },
        display: "flex",
        height: 36,
      }}
    >
      <Text lineHeight={36} style={BadgeStyle}>
        {props.children}
      </Text>
    </View>
  );
};

const MetaTextStyle = {
  ...theme.typography.body2,
  fontFamily: "Roboto",
  fontWeight: 400,
};

function formatDuration(duration?: string): string {
  if (typeof duration() !== 'string' || !duration().includes(':')) return '';
  const [hours, minutes] = duration().split(':');
  const h = parseInt(hours || '0', 10);
  const m = parseInt(minutes || '0', 10);
  return `${h} h ${m} m`;
}

function formatRating(rating?: number | string): string {
  const num = parseFloat(String(rating()));
  return !isNaN(num) ? num.toFixed(1) : '';
}

function formatReleaseYear(dateStr?: string): string {
  if (typeof dateStr() !== 'string' || !dateStr().includes('-')) return '';
  const year = dateStr().split('-')[0];
  return /^\d{4}$/.test(year) ? year : '';
}

const ContentBlock = (props) => {
  return (
    <View {...props}>

      <View y={10} height={15}>
        <Text color={"#b5b1b1"} fontSize={24}>{props.content.genre}</Text>
      </View>

      <Headline y={70} >{props.content.title}</Headline>

      <View y={150} height={30}>
        {props.content.rating && (
          <View y={-5} direction="row">
            {Array.from({ length: 5 }).map((_, index) => {
              const rawRating = props.content.rating;
              const rating = rawRating() !== undefined && rawRating() !== null && !isNaN(Number(rawRating()))
                ? parseFloat(rawRating().toString()) / 2 // Convert from 10 to 5 scale
                : 0;

              const fullStars = Math.floor(rating);
              const hasHalfStar = rating % 1 >= 0.5;

              const starSrc =
                index < fullStars
                  ? 'https://i.ibb.co/4gK6MnK/star-1.png' // Full star
                  : index === fullStars && hasHalfStar
                    ? 'https://i.ibb.co/9V7LVwc/rating.png' // Half star
                    : 'https://i.ibb.co/1KBsPWh/star-2.png'; // Empty star

              return (
                <View
                  key={index}
                  x={index * 35}
                  width={30}
                  height={30}
                  src={starSrc}
                />
              );
            })}
          </View>
        )}

        <View x={200}>
          <Text color={"#b5b1b1"} x={100} fontSize={24}> {formatRating(props.content.rating)}/10</Text>
          <Text color={"#b5b1b1"} fontSize={24}>{formatDuration(props.content.duration)}</Text>
          <Text color={"#b5b1b1"} x={200} fontSize={24}> {formatReleaseYear(props.content.release)}</Text>
        </View>

      </View>

      <Description y={200}>{props.content.description}</Description>


      <Text y={300} fontSize={24} color={"#b5b1b1"}>Director:</Text>
      <Text x={100} y={300} fontSize={24}>{props.content.director}</Text>

      <Text y={350} fontSize={24} color={"#b5b1b1"}>Cast:</Text>
      <DescriptionSecond x={60} y={350} >{props.content.cast}</DescriptionSecond>
    </View>
  );
};


export default ContentBlock;
